import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
    fetch: ( prompt_id = 1, key = '{options}', page = 1, itemsPerPage = 4 ) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('',
            formatGraphqlBody(
                'query',
                'getPrompts',
                {
                    0: 'pagination_page',
                    1: 'pagination_limit',
                    2: 'total_pages',
                    3: 'total_items',
                    items: {
                        0: 'id',
                        1: 'name',
                        2: 'key',
                        3: 'prompt_id',
                        4: 'department_id',
                        5: 'option',
                        6: 'is_active',
                        7: 'price',
                        8: 'discount_price'
                    }
                },
                {
                    key: key,
                    prompt_id: prompt_id,
                    pagination_page: page,
                    pagination_limit: itemsPerPage
                }
            )
        );
    },
    create: ( key = 'options', name, prompt_id = 1, department_id = null, price = null, discount_price = null ) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', 
            {
                query: `
                    mutation {
                        createPrompt (
                            key: "${ key }",
                            name: "${ name }",
                            prompt_id: ${ prompt_id },
                            ` + ( department_id === null ? '' : `department_id:  ${ department_id }` ) + `,
                            ` + ( price === null ? '' : `price:  ${ price }` ) + `,
                            ` + ( discount_price === null ? '' : `discount_price:  ${ discount_price }` ) + `
                        ) {
                            id,
                            name,
                            key,
                            price,
                            prompt_id,
                            department_id,
                            option,
                            is_active,
                            discount_price
                        }
                    }
                `
            }
        );
    },
    update: ( id, name = null, department_id = null, is_active = null, price = null, discount_price = null, has_redirect_flow = null ) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('',
            {
                query: `
                    mutation {
                        updatePrompt (
                            id: ${ id },
                            ` + ( name === null ? '' : `name:  "${ name }"` ) + `,
                            ` + ( department_id === null ? '' : `department_id:  ${ department_id }` ) + `,
                            ` + ( is_active === null ? '' : `is_active:  ${ is_active }` ) + `,
                            ` + ( price === null ? '' : `price:  ${ price }` ) + `,
                            ` + ( discount_price === null ? '' : `discount_price:  ${ discount_price }` ) + `,
                            ` + ( has_redirect_flow === null ? '' : `has_redirect_flow:  ${ has_redirect_flow }` ) + `
                        ) {
                            id,
                            name,
                            key,
                            prompt_id,
                            department_id,
                            is_active,
                            option,
                            discount_price,
                            price
                        }
                    }
                `
            }
        );
    },
    delete: ( id ) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', 
            {
                query: `
                    mutation {
                        deletePrompt (
                            id: ${ id }
                        )
                    }
                `
            }
        );
    },
    countOptions: () => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', 
            {
                query: `
                    query {
                        countPrompts (
                            key: "{options}"
                        )
                    }
                `
            }
        );
    }
}